import React from 'react'
import styles from './Heart.scss'
import { Icon } from 'common/Icon'
import { useFormatMessage } from 'lib/localization'
import cx from 'classnames'
import { defineMessages } from 'react-intl'
import _ from 'lodash'

const messages = defineMessages({
  like: {
    id: 'Heart.like',
    defaultMessage: 'like'
  },
  liked: {
    id: 'Heart.liked',
    defaultMessage: 'liked'
  },
  likeReport: {
    id: 'Heart.likeReport',
    defaultMessage: 'like report'
  },
  unlike: {
    id: 'Heart.unlike',
    defaultMessage: 'unlike'
  }
})

export const Heart = ({ liked, count, onClick, size, capitalized, emptyOnZero }) => {
  const fm = useFormatMessage()
  const title = capitalized
    ? _.capitalize(fm(liked ? messages.unlike : messages.like))
    : fm(liked ? messages.unlike : messages.like)
  const aMsg = capitalized
    ? _.capitalize(fm(liked ? messages.liked : messages.like))
    : fm(liked ? messages.liked : messages.like)

  return <div className={styles.Heart} onClick={onClick}>
    <Icon
      className={cx(styles.heartIcon, liked && styles.liked)}
      i={liked ? 'md-heart' : 'md-heart-outline'} size={size ?? 24}
      title={title} />
    {count && count > 0
      ? <div className={styles.count}>{count}</div>
      : <div className={styles.likeText}>{!emptyOnZero && aMsg}</div>
    }
  </div>
}

// we are going to make the Heart not float to the left, and once we do that
// this can be removed.
export const HeartClickTarget = ({ onClick }) => (
  <div className={cx(styles.Heart, styles.HeartClickTarget)} onClick={onClick} />
)
